import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllProcessViewComponent } from './all-process-view/all-process-view.component';
import { ModalSharedLoginComponent } from './login/login.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../pipes/pipes.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InputPhoneInternationalModule } from '../resources-widget/input-phone-international/input-phone-international.module';
import { InputOtpModule } from '../resources-widget/input-otp/input-otp.module';

@NgModule({
  declarations: [
    ModalSharedLoginComponent,
    AllProcessViewComponent
  ],
  imports: [
    CommonModule,
    LazyLoadImageModule,
    RouterModule,
    ReactiveFormsModule,
    PipesModule,
    NgbTooltipModule,
    InputPhoneInternationalModule,
    InputOtpModule
  ],
  exports: [
    ModalSharedLoginComponent,
    AllProcessViewComponent
  ],
})
export class ModalsSharedModule { }
